<template>
  <div>
    <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isSupplierAddActive" position-right>
      <div class="px-0 sm:pb-6 h-full tranksaksi-area-loading">
        <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-5 d-theme-dark-bg tranksaksi-header bg-primary">
          <h5 class="text-white">{{ Object.entries(this.supplierData).length === 0 ? "Tambah" : "Edit" }} Supplier</h5>
          <feather-icon :icon="$vs.rtl ? 'XIcon' : 'XIcon'" @click="supplierAddClose" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
        </div>

        <component :is="scrollbarTag" class="tranksaksi-scroll-area md:p-8 p-6 mt-base" :settings="settings" :key="$vs.rtl">
          <div class="vx-col w-full sm:w-3/4 items-center sm:flex-row flex-col mx-auto">
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-input label="Supplier" v-model="dataKontak" class="mt-5 w-full" name="item-kontak" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('item-kontak')">{{ errors.first('item-kontak') }}</span>
              </div>
            </div>
            <vs-divider class="mt-base">Informasi Umum</vs-divider>
            <div class="vx-row mb-6">
              <div class="vx-col w-1/2">
                <vs-input type="email" label="Email" v-model="dataEmail" class="mt-2 w-full" name="item-email" v-validate="'required|email'"/>
              </div>
              <div class="vx-col w-1/2">
                <vs-input label="Telepon" v-model="dataTelepon" class="mt-2 w-full" name="item-telepon" v-validate="'required|numeric'"/>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-textarea v-model="dataAlamat" label="Alamat" class="mt-1 w-full"/>
              </div>
            </div>
            <vs-divider class="mt-base">Rekening</vs-divider>
            <div class="vx-row mb-2">
              <div class="vx-col w-1/2">
                <div class="vx-row">
                  <div class="vx-col w-3/4">
                    <vs-select
                      label="Bank"
                      v-model="dataBank"
                      class="mt-2 w-full"
                      >
                        <vs-select-item value="" text="Tidak ada"/>
                        <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listBank"/>
                    </vs-select>
                  </div>
                  <div class="vx-col w-1/4">
                    <vs-button class="mt-8" @click.stop="tambahBank=true" icon-pack="feather" icon="icon-plus"></vs-button>
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/2">
                <vs-input label="Atas Nama" v-model="dataAtasNama" class="mt-2 w-full" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-input label="Nomor Rekening" v-model="dataRekening" class="mt-2 w-full" name="item-rekening" v-validate="'numeric'"/>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-1/2">
                <vs-button type="border" color="danger" @click="supplierAddClose">Cancel</vs-button>
              </div>
              <div class="vx-col w-1/2 flex justify-end">
                <vs-button :disabled="!isFormValid" @click="submitData" color="primary">Submit</vs-button>
              </div>
            </div>
          </div>
        </component>
      </div>

      <vs-prompt
        color="success"
        title="Tambah Bank"
        @accept="bankAdd"
        :active.sync="tambahBank"
        style="z-index: 52011;">
        <div class="con-exemple-prompt">
          <vs-input placeholder="Nama Bank" data-vv-name="addbank" name="addbank" v-validate="'required'" v-model="addBank" class="w-full mb-base"/>
          <span class="text-danger text-sm" v-show="errors.has('addbank')">{{ errors.first('addbank') }}</span>
          <vs-input placeholder="Kode bank" data-vv-name="addkodebank" name="addkodebank" v-validate="'required'" v-model="addkodebank"/>
          <span class="text-danger text-sm" v-show="errors.has('addkodebank')">{{ errors.first('addkodebank') }}</span>
        </div>
      </vs-prompt>

    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
export default{
  props: {
    isSupplierAddActive: {
      type: Boolean,
      required: true
    },
    supplierData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },

      dataId: null,
      dataKontak: null,
      dataGroup: 0,
      dataParent: 0,
      dataEmail: null,
      dataTelepon: null,
      dataAlamat: null,
      dataBank: '',
      dataAtasNama: null,
      dataRekening: null,

      listBank: [],

      addBank: null,
      addkodebank: null,
      tambahBank: false
    }
  },
  watch: {
    isSupplierAddActive (value) {
      if (value) {
        let configs = {
          headers: {
            'Authorization': 'Bearer ' + this.user.api_token,
          },
        }
        this.axios.get('/term-list/bank', configs)
        .then((response) => {
          let {data} = response.data
          this.listBank = data
        })
        .catch((error) => {
          let data = error.data
          this.listBank = data
        })

        if (Object.entries(this.supplierData).length === 0) {
          this.initValues()
          this.$validator.reset()
        } else {
          const { id, name, term_group, parent, email, telepon, alamat, bank, atasnama, rekening  } = JSON.parse(JSON.stringify(this.supplierData))
          this.dataId = id
          this.dataKontak = name
          this.dataGroup = term_group
          this.dataParent = parent
          this.dataBank = bank
          this.dataEmail = email
          this.dataTelepon = telepon
          this.dataAlamat = alamat
          this.dataBank = bank
          this.dataAtasNama = atasnama
          this.dataRekening = rekening
          this.initValues()
        }
      } else { return } 
    }
  },
  computed: {
    scrollbarTag () { 
      return this.$store.getters.scrollbarTag
    },
    windowWidth ()  { 
      return this.$store.state.windowWidth                 
    },
    isFormValid () {
      return !this.errors.any() && this.dataKontak && this.dataGroup && this.dataBank
    },
    validateBank() {
      return !this.errors.any() && this.addBank !== null && this.addkodebank !== null
    },
    ...mapGetters({
      user : 'auth/user',
    })
  },
  methods: {
    initValues() {
      if (this.supplierData.id) return
      this.dataId = null
      this.dataKontak = null
      this.dataGroup = '217'
      this.dataParent = 0
      this.dataEmail = null
      this.dataTelepon = null
      this.dataAlamat = null
      this.dataBank = ''
      this.dataAtasNama = null
      this.dataRekening = null
    },
    supplierAddClose() {
      this.$emit('closeSupplierAdd')
    },
    bankAdd() {
      this.$vs.loading()
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let formData = {
        name : this.addBank,
        term_group: 0,
        parent: 0,

        meta : {
          kode: this.addkodebank,
        },

        taxonomy: 'bank'
      }

      this.axios.post('/term-add', formData, configs)
      .then((response) => {
        this.listBank = []
        this.addBank = null
        this.addkodebank = null
        this.loadBank()

        this.$vs.notify({
          title: response.message,
          color  : 'success',
          text  : 'Bank telah bertambah',
        })
        this.$vs.loading.close()

      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response

        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

    },
    loadBank () {
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/bank', configs)
      .then((response) => {
        let {data} = response.data
        this.listBank = data
      })
      .catch((error) => {
        let data = error.data
        this.listBank = data
      })
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataKontak,
            term_group: this.dataGroup,
            parent: this.dataParent,

            meta : {
              email: this.dataEmail,
              telepon: this.dataTelepon,
              alamat: this.dataAlamat,

              bank: this.dataBank,
              atasnama: this.dataAtasNama,
              rekening: this.dataRekening,
            },
            taxonomy: 'kontak'
          }

          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('supplier/updateKontak', obj)
          } else {
            delete obj.id
            this.$store.dispatch('supplier/addKontak', obj)
          }
          this.$emit('closeSupplierAdd')
          this.initValues()
        }
      })
    }
  }
}

</script>